module.exports = __webpack_public_path__ + "img/abbbb71d36f6943e10b46c8ccea2645c.36aeeb52.png";